/**
 * Persistencia del resultado de Screen QA (GSDF / TG18-QC visual).
 * localStorage — no sustituye calibración fotométrica.
 */

export const GSDF_QA_STORAGE_KEY = 'udv.gsdfQa'

/**
 * @typedef {{
 *   gsdf_qa_passed: boolean,
 *   last_check_timestamp: string,
 *   device_info: string,
 * }} GsdfQaResult
 */

/**
 * @returns {GsdfQaResult|null}
 */
export function getGsdfQaResult() {
  try {
    const raw = localStorage.getItem(GSDF_QA_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return {
      gsdf_qa_passed: !!parsed.gsdf_qa_passed,
      last_check_timestamp: String(parsed.last_check_timestamp || ''),
      device_info: String(parsed.device_info || ''),
    }
  } catch (e) {
    return null
  }
}

/** @returns {boolean} */
export function isGsdfQaPassed() {
  const r = getGsdfQaResult()
  return !!(r && r.gsdf_qa_passed)
}

/**
 * Guarda un resultado aprobado (los 3 checks válidos).
 * @returns {GsdfQaResult}
 */
export function setGsdfQaPassed() {
  /** @type {GsdfQaResult} */
  const next = {
    gsdf_qa_passed: true,
    last_check_timestamp: new Date().toISOString(),
    device_info:
      (typeof navigator !== 'undefined' && navigator.userAgent) || '',
  }
  try {
    localStorage.setItem(GSDF_QA_STORAGE_KEY, JSON.stringify(next))
  } catch (e) {
    /* ignore quota / private mode */
  }
  return next
}

export function clearGsdfQaResult() {
  try {
    localStorage.removeItem(GSDF_QA_STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
